import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';
import { Column, SectionTitle } from '../../../themes/styles/plan-overview';
import { PortfolioPieChart } from '../../molecules/PortfolioPieChart/PortfolioPieChart';
import useMarketPortfolioData from '../PortfolioComposition/useMarketPortfolioData';
import { useGetPortfolioCompositionData } from '../PortfolioComposition/useGetPortfolioCompositionData';
import { useAppSelector } from '../../../common/hooks';

export const PortfolioCompositionSection = ({ selectedGoalIndex }: { selectedGoalIndex: number }) => {
    const { t } = useTranslation();
    const { portfolio } = useAppSelector((state) => state.global);
    const { response, formFields } = useAppSelector((state) => state?.adviceGoals);
    const selectedResponse = response[selectedGoalIndex];
    const selectedGoal = formFields?.[selectedGoalIndex]?.data;
    const recommendedPortfolioId =
        selectedResponse?.['response']?.['body']?.['analysisReport']?.['recommendedPortfolioId'];
    const { portfolioCompositionSource } = useMarketPortfolioData(selectedGoal?.goalCategory);
    const allMarketPortfolios = portfolioCompositionSource?.length ? portfolioCompositionSource : portfolio;

    // Select the correct source for composition (tactical if available, otherwise strategic)
    const { doughnutChartData, groupedPortfolio } = useGetPortfolioCompositionData(
        recommendedPortfolioId,
        portfolioCompositionSource?.length ? portfolioCompositionSource : allMarketPortfolios,
        true // onlySingleColor set to true
    );

    return (
        <Column>
            <Box>
                <SectionTitle sx={{ display: 'flex', justifyContent: 'center', marginBottom: '50px' }}>
                    {t('LABEL_PORTFOLIO_COMPOSITION_SHORT')}
                </SectionTitle>
                <PortfolioPieChart doughnutChartData={doughnutChartData} groupedPortfolio={groupedPortfolio} />
            </Box>
        </Column>
    );
};
